import {
	BookOutlined,
	PlusOutlined,
	ReadOutlined,
	TeamOutlined,
	UserOutlined,
} from '@ant-design/icons';
import { Button, Card, Col, Row, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/constants';

const QuickActions = () => {
	const { t } = useTranslation('components');
	const navigate = useNavigate();

	const actions = [
		{
			key: 'add-breed',
			label: t('dashboard.quickActions.addBreed'),
			icon: ReadOutlined,
			onClick: () => navigate(ROUTES.BREEDS),
			type: 'primary' as const,
			tooltip: t('dashboard.quickActions.addBreedTooltip'),
		},
		{
			key: 'add-resource',
			label: t('dashboard.quickActions.addResource'),
			icon: BookOutlined,
			onClick: () => navigate(ROUTES.RESOURCES),
			type: 'default' as const,
			tooltip: t('dashboard.quickActions.addResourceTooltip'),
		},
		{
			key: 'manage-users',
			label: t('dashboard.quickActions.manageUsers'),
			icon: UserOutlined,
			onClick: () => navigate(ROUTES.USERS),
			type: 'default' as const,
			tooltip: t('dashboard.quickActions.manageUsersTooltip'),
		},
		{
			key: 'view-pets',
			label: t('dashboard.quickActions.viewPets'),
			icon: TeamOutlined,
			onClick: () => navigate(ROUTES.PETS),
			type: 'default' as const,
			tooltip: t('dashboard.quickActions.viewPetsTooltip'),
		},
	];

	return (
		<Card
			title={
				<div className='flex items-center gap-2'>
					<PlusOutlined className='text-indigo-600' />
					<span className='font-semibold text-slate-700'>
						{t('dashboard.quickActions.title')}
					</span>
				</div>
			}
			className='h-full border border-slate-100 shadow-sm rounded-xl'
			styles={{ body: { padding: '16px' } }}
		>
			<Row gutter={[12, 12]}>
				{actions.map((action) => {
					const IconComponent = action.icon;
					return (
						<Col span={12} key={action.key}>
							<Tooltip title={action.tooltip} placement='top'>
								<Button
									onClick={action.onClick}
									block
									size='large'
									className={`
										h-auto py-4 rounded-lg font-medium transition-all
										${action.type === 'primary'
											? 'bg-indigo-600 hover:bg-indigo-500 text-white border-indigo-600 hover:border-indigo-500'
											: 'bg-white border-slate-200 hover:border-indigo-400 hover:text-indigo-600 text-slate-700'
										}
									`}
								>
									<div className='flex flex-col items-center gap-2'>
										<IconComponent className='text-xl' />
										<span className='text-xs font-medium'>{action.label}</span>
									</div>
								</Button>
							</Tooltip>
						</Col>
					);
				})}
			</Row>

			<div className='mt-4 pt-4 border-t border-slate-100'>
				<div className='flex gap-2'>
					<Button
						type='text'
						size='small'
						onClick={() => navigate('/analytics')}
						className='text-slate-500 hover:text-indigo-600 text-xs'
					>
						{t('dashboard.quickActions.analytics')}
					</Button>
					<Button
						type='text'
						size='small'
						onClick={() => navigate(ROUTES.SETTINGS)}
						className='text-slate-500 hover:text-indigo-600 text-xs'
					>
						{t('dashboard.quickActions.settings')}
					</Button>
				</div>
			</div>
		</Card>
	);
};

export { QuickActions };
export default QuickActions;
